import { Button, Heading, VStack } from '@chakra-ui/react'
import React from 'react'

const index = () => (
  <VStack h="100vh" w="100vw" role="alert" justifyContent="center" alignItems="center" spacing="20px">
    <Heading size="lg">Ooops, something went wrong :( </Heading>
    <Button colorScheme="blue" onClick={() => window.location.reload()}>
      Refresh
    </Button>
  </VStack>
)

export default index
